import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';
import { POST_ROWS_PER_PAGE } from '@src/utils/constants';

export const postsApi = createApi({
  reducerPath: 'postsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPosts: builder.query({
      query: (filter = { page: 1, limit: POST_ROWS_PER_PAGE }) => ({
        url: `posts`,
        method: 'GET',
        params: filter,
      }),
      providesTags: ['Posts'],
    }),
    getPopularTags: builder.query({
      query: ({ limit = 11, recentPostsCount = 20 } = {}) => ({
        url: `posts/popular-tags`,
        method: 'GET',
        params: { limit, recentPostsCount },
      }),
      providesTags: ['Posts'],
    }),
    getCategories: builder.query({
      query: () => ({
        url: `posts/categories`,
        method: 'GET',
      }),
      providesTags: ['Posts'],
    }),
    getPostBySlug: builder.query({
      query: (slug) => ({
        url: `posts/slug/${slug}`,
        method: 'GET',
      }),
      providesTags: (result, error, slug) => [{ type: 'Posts', id: slug }],
    }),
    createPost: builder.mutation({
      query: (newPost) => ({
        url: `posts`,
        method: 'POST',
        body: newPost,
      }),
      invalidatesTags: ['Posts'],
    }),
    uploadCoverImage: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `posts/upload-cover-image`,
          method: 'POST',
          body: formData,
        };
      },
    }),
    uploadContentImage: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `posts/upload-content-image`,
          method: 'POST',
          body: formData,
        };
      },
    }),
    updatePost: builder.mutation({
      query: ({ id, ...updates }) => ({
        url: `posts/${id}`,
        method: 'PUT',
        body: updates,
      }),
      invalidatesTags: ['Posts'],
    }),
    deletePost: builder.mutation({
      query: (id) => ({
        url: `posts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Posts'],
    }),
  }),
});

export const {
  useGetPostsQuery,
  useGetPopularTagsQuery,
  useGetCategoriesQuery,
  useGetPostBySlugQuery,
  useCreatePostMutation,
  useUploadCoverImageMutation,
  useUploadContentImageMutation,
  useUpdatePostMutation,
  useDeletePostMutation,
} = postsApi;
